"use strict";
exports.__esModule = true;
var utils_1 = require("../utils");
var exceptions_1 = require("../exceptions");
function defaultShowAction(scrollX, scrollY) {
    var document = window.document;
    var documentElement = document.documentElement, body = document.body;
    var scrollSignal = document.createElement("div");
    scrollSignal.style.zIndex = "2000";
    scrollSignal.style.border = "3px solid red";
    scrollSignal.style.width = documentElement.clientWidth - 25 + "px";
    scrollSignal.style.height = documentElement.clientHeight - 25 + "px";
    scrollSignal.style.position = "absolute";
    scrollSignal.style.transition = "opacity 1s ease-out";
    scrollSignal.style.left = scrollX + 10 + "px";
    scrollSignal.style.top = scrollY + 10 + "px";
    var element = body.appendChild(scrollSignal);
    setTimeout(function () {
        body.removeChild(element);
    }, 1000);
    setTimeout(function () {
        element.style.opacity = "0";
    }, 50);
}
function scroller() {
    var document = window.document;
    var documentElement = document.documentElement, body = document.body;
    var config = {
        positionSelector: defaultPositionSelector,
        showAction: defaultShowAction,
        logger: console,
        randomizer: null
    };
    function defaultPositionSelector() {
        if (config.randomizer === null) {
            return [0, 0];
        }
        var documentWidth = Math.max(body.scrollWidth, body.offsetWidth, documentElement.scrollWidth, documentElement.offsetWidth, documentElement.clientWidth);
        var documentHeight = Math.max(body.scrollHeight, body.offsetHeight, documentElement.scrollHeight, documentElement.offsetHeight, documentElement.clientHeight);
        return [
            config.randomizer.natural({
                max: documentWidth - documentElement.clientWidth
            }),
            config.randomizer.natural({
                max: documentHeight - documentElement.clientHeight
            })
        ];
    }
    function scrollerGremlin() {
        if (!config.randomizer) {
            throw new exceptions_1.RandomizerRequiredException();
        }
        var position = config.positionSelector(), scrollX = position[0], scrollY = position[1];
        window.scrollTo(scrollX, scrollY);
        if (typeof config.showAction === "function") {
            config.showAction(scrollX, scrollY);
        }
        if (typeof config.logger.log === "function") {
            config.logger.log("gremlin", "scroller  ", "scroll to", scrollX, scrollY);
        }
    }
    utils_1.configurable(scrollerGremlin, config);
    return scrollerGremlin;
}
exports.scroller = scroller;
